import type { Module } from './DracoEncoder';
import loadModule from './DracoEncoder';
import moduleUrl from './DracoEncoder.wasm?url';

const _instance: Record<string, unknown> = {};

export async function loadWasmModule(): Promise<void> {
  const instance = await loadModule({ locateFile: () => moduleUrl });
  _instance._module = instance;
  Object.assign(_instance, instance);
}

export default _instance as unknown as Module;

export * from './DracoEncoder';
